<template>
	<div>
		<div v-if="isBirthday" class="birthday-message mb-5">
			<h1>Happy Birthday! 🎂🎉🥳🎈</h1>
			<div id="balloons"></div>
			<!-- <div id="confetti"></div> -->
		</div>
		<!-- other content -->
	</div>
</template>

<script setup>
	import { ref, computed, watch, nextTick } from "vue"
	import party from "party-js"
	import moment from "moment-timezone"

	const props = defineProps({ user: Object })

	const isBirthday = computed(() => {
		return (
			props.user?.birthday &&
			moment().format("MM/DD") === moment(props.user?.birthday).format("MM/DD")
		)
	})

	function triggerBday() {
		if (isBirthday.value) {
			// Trigger balloons animation
			animateBalloons()

			// Trigger confetti animation
			party.confetti(document.getElementById("app"), {
				count: 100,
				size: 1.25,
			})
		}
	}

	function animateBalloons() {
		const container = document.getElementById("balloons")
		for (let i = 0; i < 6; i++) {
			const balloon = document.createElement("div")
			balloon.className = "balloon"
			balloon.style.left = `${Math.random() * 100}%`
			balloon.style.bottom = `-150px`
			balloon.style.animationDelay = `${Math.random() * 2}s`
			container.appendChild(balloon)

			// Remove the balloon once the animation ends
			balloon.addEventListener("animationend", () => {
				balloon.remove()
			})
		}
	}

	watch(isBirthday, (v) => {
		nextTick(() => {
			triggerBday()
		})
	})
</script>

<style>
	/* Scoped styles for birthday message */
	.birthday-message {
		text-align: center;
		/* margin-top: 20px; */
		font-size: 2em;
		color: #ff6347; /* Tomato color */
		animation: fadeIn 2s ease-in-out;
		font-weight: bolder;
	}

	/* Global styles for balloons */
	#balloons {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		pointer-events: none;
		z-index: 1000; /* Ensure balloons are on top */
	}

	.balloon {
		position: fixed;
		width: 50px;
		height: 70px;
		background-color: #ff6347;
		border-radius: 50% 50% 45% 45%; /* More balloon-like shape */
		opacity: 0.8;
		animation: float 5s ease-in-out forwards;
	}

	.balloon::before {
		content: "";
		position: absolute;
		bottom: -40px; /* Adjust to make the string longer */
		left: 50%;
		width: 2px;
		height: 40px; /* Adjust to make the string longer */
		background-color: #333;
	}

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes float {
		0% {
			transform: translateY(0);
			/* opacity: 1; */
		}
		100% {
			transform: translateY(-110vh);
			/* opacity: 0; */
		}
	}
</style>
